import { useState,useEffect } from "react";
import { useForm } from "react-hook-form";
import NitroButton from '../parts/NitroButton';
import jQuery from 'jquery';

const Heatmap = ({qData, nextStep}) => {

  const [boxSize, setBoxSize] = useState([]);
  const [src, setSrc] = useState('');

  let dotSize = 44;
  let dotSet = false;

  const dotStyles = {
    'width': dotSize+'px',
    'height': dotSize+'px',
    'borderRadius': '100%',
    'opacity': 0.88
  }

  useEffect(() => {
    window.addEventListener('scroll', handleResize);
    document.body.addEventListener('scroll', handleResize);
    window.addEventListener('resize', handleResize)

    setSrc(qData.image_url);
    handleResize();
  }, [])

  const handleImageLoad = (event) => {
    //setImgSize([event.target.clientWidth, event.target.clientHeight]);
    let box = document.getElementById("heatmap");
    var rect = box.getBoundingClientRect();
    setBoxSize([rect.left, rect.top, rect.width, rect.height])
    let dot = document.getElementById("heatmap_dot");
    if (dotSet == false){
      dot.style.left = (rect.width / 2) + 'px';
      dot.style.top = (rect.height / 2) + 'px';
      dotSet = true;
    }
  }

  const handleKeyDown = (event) => {

    if (event.key.startsWith("Arrow")) {
      event.preventDefault()
      event.stopPropagation()

      let sens = parseInt(boxSize[2]/40),
        dot = document.getElementById("heatmap_dot"),
        currentX = dot.offsetLeft,
        currentY = dot.offsetTop;
        console.log('width?',boxSize[2])
        console.log('sens:',sens)
      if (event.key === "ArrowLeft") {
        dot.style.left = (currentX - sens) + 'px';
      } else if (event.key === "ArrowRight") {
        dot.style.left = (currentX + sens) + 'px';
      } else if (event.key === "ArrowUp") {
        dot.style.top = (currentY - sens) + 'px';
      } else if (event.key === "ArrowDown") {
        dot.style.top = (currentY + sens) + 'px';
      }
    }

  }

  const handleImageClick = (e) => {
    let dot = document.getElementById("heatmap_dot");
    var x = e.clientX - boxSize[0]; //x position within the element.
    dot.style.left = x - (dotSize/2) + 'px';
    var y = e.clientY - boxSize[1];  //y position within the element.
    dot.style.top = y - (dotSize/2) + 'px';
  }

  const handleResize = () => {
    handleImageLoad()
  }

  const { handleSubmit, formState: { isValid } } = useForm();
  const onSubmit = (data) => {

    let dot = document.getElementById("heatmap_dot");
    const heatmapValue = pixels2values(
      dot.offsetLeft, dot.offsetTop,
      boxSize[0], boxSize[1],
      qData.min_x.value,
      qData.min_y.value,
      qData.max_x.value,
      qData.max_y.value);
    const dataToSend = {
      "questionId": qData.id,
      "heatmapValue": heatmapValue
    }

    nextStep(dataToSend);
  }


  /*
  function pixels2values

  takes arguments
    px - pixels user clicked from left edge of image
    py - pixels user clicked from top edge of image
    image_width - current width of image
    image_height - height of image
    vx_min - min x scale value
    vx_max - max x scale value
    vy_min - min y scale value
    vy_max - max y scale value

  returns array of
    x_value
    y_value
  */

  function pixels2values(px, py, image_width, image_height, vx_min, vy_min, vx_max, vy_max) {
    return [
      (px / image_width) * (vx_max - vx_min) + vx_min,
      (py / image_height) * (vy_max - vy_min) + vy_min,
    ];
  }

  return (
    <>
      <div className="grow py-6 md:py-12">
        <div className="container max-w-xl">

          <div id="heatmap" className="heatmap w-full h-max relative overflow-hidden" onClick={handleImageClick} onKeyDown={handleKeyDown} tabIndex="0">
              <div id="heatmap_dot" className="absolute heatmap_dot" style={dotStyles}></div>
              <img alt="Map" src={src} onLoad={handleImageLoad} />
            </div>

          </div>
        </div>
      <NitroButton label="Next" formIsValid={isValid} onClick={handleSubmit(onSubmit)} />
      </>

  );
}

export default Heatmap;
